module.exports = __webpack_public_path__ + "media/images/values/driven-5c55a873d61457be791bcba9b4b1d8bf.svg";